export interface Track {
  id: number;
  title: string;
  artist: string;
  album: string;
  year: number;
  genre: string[];
  duration: string;
  coverArt?: string;
  audioUrl?: string;
}

export const musicData: Track[] = [
  {
    id: 1,
    title: 'Digital Dreams',
    artist: 'Peter-AR',
    album: 'Synthetic Horizons',
    year: 2024,
    genre: ['Electronic', 'Ambient'],
    duration: '4:32',
    audioUrl: '#'
  },
  {
    id: 2,
    title: 'Code Flow',
    artist: 'Peter-AR',
    album: 'Synthetic Horizons',
    year: 2024,
    genre: ['Electronic', 'Techno'],
    duration: '5:18',
    audioUrl: '#'
  },
  {
    id: 3,
    title: 'Midnight Debugging',
    artist: 'Peter-AR',
    album: 'Developer\'s Journey',
    year: 2023,
    genre: ['Lo-fi', 'Chill'],
    duration: '3:45',
    audioUrl: '#'
  },
  {
    id: 4,
    title: 'Binary Sunset',
    artist: 'Peter-AR',
    album: 'Developer\'s Journey',
    year: 2023,
    genre: ['Synthwave', 'Retro'],
    duration: '4:12',
    audioUrl: '#'
  },
  {
    id: 5,
    title: 'Recursive Dreams',
    artist: 'Peter-AR',
    album: 'Algorithm EP',
    year: 2023,
    genre: ['Experimental', 'Electronic'],
    duration: '6:02',
    audioUrl: '#'
  },
  {
    id: 6,
    title: 'Cloud Nine',
    artist: 'Peter-AR',
    album: 'Singles',
    year: 2022,
    genre: ['House', 'Progressive'],
    duration: '7:28',
    audioUrl: '#'
  }
];